import store from '@/store';
import i18n from '@/i18n';

export default {
    items: [
        {
            route: 'account.dashboard',
            hamburgerMenu: {
                icon: 'dashboard.png',
                label: 'Dashboard',
                order: 1,
                enabled: true,
            },
        },
        {
            route: 'account.free-flowers',
            hamburgerMenu: {
                icon: 'free-boxes.svg',
                label: 'Free boxes',
                order: 8,
                enabled: true,
            },
            dashboard: {
                image: 'raf-icon',
                label: i18n.t('DASHBOARD_TILE_LABEL_RAF'),
                counterGetterName: 'account/getUserInvitesRemaining',
                order: 1,
                enabled: true,
                newDashboardSection: 1,
                newDashboardMobileSection: 1,
                oldDashboardSection: 1,
                oldDashboardMobileSection: 1,
            },
            myAccount: {
                icon: 'free-boxes.svg',
                label: 'Free boxes',
                order: 4,
                enabled: true,
            },
        },
        {
            route: 'account.rate-my-flowers',
            hamburgerMenu: {
                icon: 'rate-my-flowers.svg',
                label: 'Rate my flowers',
                order: 7,
                enabled: true,
            },
            dashboard: {
                image: 'rate-my-flowers',
                label: 'Rate your flowers',
                order: 4,
                enabled: true,
                newDashboardSection: 2,
                newDashboardMobileSection: 2,
                oldDashboardSection: 2,
                oldDashboardMobileSection: 2,
            },
            myAccount: {
                icon: 'rate-my-flowers.svg',
                label: 'Rate my flowers',
                order: 3,
                enabled: true,
            },
        },
        {
            route: 'account.your-boxes',
            hamburgerMenu: {
                icon: 'your-boxes.svg',
                label: 'What\'s in the box?',
                order: 6,
                enabled: true,
            },
            dashboard: {
                image: 'your-boxes',
                label: 'What\'s in the box?',
                order: 6,
                enabled: true,
                newDashboardSection: 1,
                newDashboardMobileSection: 2,
                oldDashboardSection: 2,
                oldDashboardMobileSection: 2,
            },
            myAccount: {
                icon: 'your-boxes.svg',
                label: 'What\'s in the box?',
                order: 2,
                enabled: true,
            },
        },
        {
            route: 'account.gifting.choose-your-gift',
            hamburgerMenu: {
                icon: 'send-a-gift.svg',
                label: 'Gifting',
                order: 2,
                enabled: true,
            },
            dashboard: {
                image: 'gift',
                label: 'Gifting',
                order: 2,
                enabled: true,
                newDashboardSection: 1,
                newDashboardMobileSection: 1,
                oldDashboardSection: 1,
                oldDashboardMobileSection: 1,
            },
        },
        {
            route: 'account.delivery-schedule',
            hamburgerMenu: {
                icon: 'delivery-schedule.svg',
                label: 'Calendar',
                order: 5,
                enabled: true,
            },
            dashboard: {
                image: 'upcoming-deliveries',
                label: 'Calendar',
                order: 4,
                enabled: true,
                newDashboardSection: 1,
                newDashboardMobileSection: 2,
                oldDashboardSection: 2,
                oldDashboardMobileSection: 2,
            },
            myAccount: {
                icon: 'delivery-schedule.svg',
                label: 'Calendar',
                order: 1,
                enabled: true,
            },
        },
        {
            route: 'account.shop',
            hamburgerMenu: {
                icon: 'shop.svg',
                label: 'Shop',
                order: 3,
                enabled: process.env.VUE_APP_SHOP_ENABLED === 'true',
            },
            dashboard: {
                image: 'shop',
                label: 'Shop',
                order: 3,
                enabled: process.env.VUE_APP_SHOP_ENABLED === 'true',
                oldDashboardSection: 1,
                oldDashboardMobileSection: 2,
            },
        },
        {
            route: 'account.delivery-addresses',
            hamburgerMenu: {
                icon: 'delivery-addresses.svg',
                label: 'Delivery addresses',
                order: 9,
                enabled: true,
            },
            dashboard: {
                image: 'address',
                label: 'Your addresses',
                order: 7,
                enabled: true,
                newDashboardSection: 2,
                newDashboardMobileSection: 2,
                oldDashboardSection: 2,
                oldDashboardMobileSection: 2,
            },
            myAccount: {
                icon: 'delivery-addresses.svg',
                label: 'Delivery addresses',
                order: 6,
                enabled: true,
            },
        },
        {
            route: 'blog',
            target: '_blank',
            dashboard: {
                image: 'blog',
                label: 'Flower blog',
                order: 10,
                enabled: false,
            },
        },
        {
            route: 'account.manage-account',
            hamburgerMenu: {
                icon: 'account.svg',
                label: 'Your account',
                order: 10,
                enabled: true,
            },
            dashboard: {
                image: 'manage-account',
                label: 'Your account details',
                order: 8,
                enabled: true,
                newDashboardSection: 2,
                newDashboardMobileSection: 2,
                oldDashboardSection: 2,
                oldDashboardMobileSection: 2,
            },
            myAccount: {
                icon: 'account.svg',
                label: 'Your account',
                order: 7,
                enabled: true,
            },
        },
        {
            route: 'faq.categories',
            hamburgerMenu: {
                icon: 'dashboard.png',
                label: 'Help',
                order: 4,
                enabled: true,
            },
        },
        {
            route: 'logout',
            hamburgerMenu: {
                icon: 'account.svg',
                label: 'Sign out',
                order: 11,
                enabled: true,
            },
            dashboard: {
                image: 'manage-account',
                label: 'Sign out',
                order: 8,
                enabled: false,
            },
            myAccount: {
                icon: 'account.svg',
                label: 'Sign out',
                order: 8,
                enabled: true,
            },
        },
        {
            route: 'account.gifting-reminders',
            hamburgerMenu: {
                icon: 'Gifting-Dates-Icon.png',
                label: 'Gifting Reminders',
                order: 5,
                enabled: store.getters['account/getSpecialDatesEnabled'],
            },
            dashboard: {
                image: 'Gifting-Dates-Icon',
                label: 'Gifting Reminders',
                order: 5,
                enabled: store.getters['account/getSpecialDatesEnabled'],
                newDashboardSection: 2,
                newDashboardMobileSection: 2,
                oldDashboardSection: 2,
                oldDashboardMobileSection: 2,
            },
            myAccount: {
                icon: 'Gifting-Dates-Icon.png',
                label: 'Gifting Reminders',
                order: 5,
                enabled: true,
            },
        },
    ],
};
